import { ProjectTeamEmailMode } from 'generated/graphql';
import { projectTeamEmailToOptionsMap } from 'helpers/projectTeamEmailMode';
import { Tag, TagSize, Tooltip } from '@spotted-zebra-uk/ui-components';
import { MODE_TAG_COLOR, TOOLTIP_CONTENT } from './ProjectModeTag.helpers';
import styles from './ProjectModeTag.module.scss';

const ProjectModeTag = ({ mode }: { mode: ProjectTeamEmailMode }) => {
  return (
    <Tooltip content={TOOLTIP_CONTENT[mode]} className={styles.container}>
      <div>
        <Tag
          size={TagSize.LARGE}
          tagColor={MODE_TAG_COLOR[mode]}
          isDismissible={false}
          isPresentational={true}
          containerClass={styles.tagContainer}
        >
          {projectTeamEmailToOptionsMap[mode].label}{' '}
          {`${mode !== ProjectTeamEmailMode.Disabled ? 'emails' : ''}`}
        </Tag>
      </div>
    </Tooltip>
  );
};

export default ProjectModeTag;
